<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("Brands")}}</h4>
                <p class="text-subtitle-1">{{$t("List of Brands")}}</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-2">
            <v-col cols="12" md="3" v-if="hasPermission(permissions.brand.create)">
                <v-btn block color="primary" @click="$router.push({ name: 'BrandCreate' })">
                    <v-icon left>mdi-plus</v-icon>
                    {{$t("add_a_brand")}}
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn block depressed>
                    <v-icon left>mdi-magnify</v-icon>
                    {{$t("search")}}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="data"
                    :loading="loading"    
                >
                    <template v-slot:[`item.name`]="{item}">
                        <v-btn icon @click="handleClickRow(item)">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        {{item.name}}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import service from "@/services/fleet/brand";
import permissions from "../../../data/permissions";
import authorize from "../../../utils/authorize";
export default {
    name: "BrandListView",
    data() {
        return {
            headers: [
                { text: this.$t('name'), value: "name" },
            ],
            data: [],
            loading: false,
            permissions
        }
    },
    methods: {
        hasPermission(code) {
            return authorize(code)
        },
        fetchbrands() {
            this.loading = true;
            service.list().then(response => {
                this.data = response.data
            }).finally(() => {
                this.loading = false;
            })
        },
        handleClickRow(brand) {
            this.$router.push({ name: "BrandDisplay" , params: { brandID : brand.id } })
        }
    },
    created() {
        this.fetchbrands()
    }
}
</script>

<style>

</style>